import React, { Component } from "react";
import "./style.css";
import "../../../../index.css";
class BuyNow extends Component {
  render() {
    const { visible, discounts } = this.props;
    return (
      <div className={visible === true ? "buy_box" : "buy_box display_none"}>
        <a href="tel:13067852167" className="fl buy_service_box">
          <img alt="" src={require("../../../../images/pay/service.png")}></img>
          <div>客服</div>
        </a>
        <div
          onClick={() => this.props.handleShowAndClosePayNow()}
          className="fr buy_now_box"
        >
          <img
            style={discounts !== 0 ? { display: "block" } : { display: "none" }}
            alt=""
            src={require("../../../../images/pay/discounts.png")}
          ></img>
          <div
            style={discounts !== 0 ? { display: "block" } : { display: "none" }}
          >
            激活码已经优惠￥{discounts}
          </div>
          立即购买
        </div>
      </div>
    );
  }
}

export default BuyNow;



// WEBPACK FOOTER //
// ./src/containers/Pay/components/BuyNow/index.js